import { renderToStaticMarkup } from "react-dom/server";
import { config, styled } from "~/stitches.config";
import { encodeSvg } from "~/utils/encode-svg";
import { Icon } from "./icon";

const tickIcon = renderToStaticMarkup(
  <Icon name="tick" style={{ color: config.theme.colors.indigo }} />
);

export const Checklist = styled("ul", {
  spacing: "inherit",
  listStyle: "none",
  pl: "2.5em",
  "& > li": {
    position: "relative",
    "&:before": {
      size: "1.5em",
      content: `url("data:image/svg+xml,${encodeSvg(tickIcon)}")`,
      position: "absolute",
      transform: "translate(-2.5em, 0em)",
      display: "block",
    },
  },
});
